import {
  Button,
  Drawer,
  Form,
  Space,
  DatePicker,
  Select,
  TimePicker,
  InputNumber,
  Input,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";

const CreateDeduction = ({
  open,
  close,
  employeeInfo,
  rerun,
  date_from,
  date_to,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  //   const [selectedDate, setSelectedDate] = useState(null);
  //   const [daySubStatus, setDaySubStatus] = useState(null);
  //   const [timeIn, setTimeIn] = useState(null);
  //   const [timeOut, setTimeOut] = useState(null);

  const handleCreateDeduction = (values) => {
    const formdata = new FormData();
    formdata.append("merchant_id", userData.data.id);
    formdata.append(
      "user_id",
      employeeInfo.ready && employeeInfo.data[0].user_id
    );
    formdata.append("date_from", date_from);
    formdata.append("date_to", date_to);

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    // setLoading(true);
    axios
      .post("user/merchant/create/employee-deduction", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "success") {
          rerunNotif("success", "Created deduction successfully.");
          setTimeout(() => {
            rerun();
            close();
            setLoadings(false);
            // setLoading(false);
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Create Deduction"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="add-employee-deduction"
        onFinish={handleCreateDeduction}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item name="description" label="Description">
            <Input placeholder="Set description" size="large" />
          </Form.Item>

          <Form.Item
            name="amount"
            label="Amount"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber
              min={1}
              max={999999999999}
              initialvalues={0}
              size="large"
              style={{ width: "100%" }}
              step="0.01"
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default CreateDeduction;
